export default "__VITE_ASSET__BeF9XWlq__"